import { Box, HStack, Stack, Text } from '@chakra-ui/react';
import { useColorModeValue } from '@/components/ui/color-mode';
import { useI18n } from 'src/i18n/I18nContext';

interface PereginSymbolProps {
    size?: string | number | Record<string, string | number>;
}

export const PereginSymbol = ({ size = '2.5rem' }: PereginSymbolProps) => {
    const outline = useColorModeValue('rgba(15, 35, 63, 0.10)', 'rgba(255, 255, 255, 0.18)');

    return (
        <Box
            boxSize={size}
            flexShrink={0}
            aria-hidden='true'
        >
            <svg viewBox='0 0 48 48' width='100%' height='100%'>
                <rect x='2' y='2' width='44' height='44' rx='14' fill='#10233f' stroke={outline} strokeWidth='2' />
                <path
                    d='M15 36V13h12.2c6.4 0 10.3 3.5 10.3 9s-3.9 9-10.3 9H15'
                    fill='none'
                    stroke='#62b3a3'
                    strokeWidth='4.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <circle cx='15' cy='13' r='3.2' fill='#f6f3ea' />
                <circle cx='37.5' cy='22' r='3.2' fill='#dca443' />
                <circle cx='15' cy='36' r='3.2' fill='#62b3a3' />
            </svg>
        </Box>
    );
};

interface PereginBrandProps {
    compactOnMobile?: boolean;
    showDescriptor?: boolean;
    symbolOnly?: boolean;
}

const PereginBrand = ({
    compactOnMobile = false,
    showDescriptor = false,
    symbolOnly = false,
}: PereginBrandProps) => {
    const { t } = useI18n();
    const wordmarkColor = useColorModeValue('#10233f', '#f7f8f5');

    return (
        <HStack gap={showDescriptor ? '3' : '2.5'} minW='0' data-testid='peregin-brand'>
            <PereginSymbol size={showDescriptor ? '3rem' : { base: '2.15rem', sm: '2.4rem' }} />
            {!symbolOnly && (
                <Stack
                    gap='0'
                    minW='0'
                    display={compactOnMobile ? { base: 'none', sm: 'flex' } : 'flex'}
                >
                    <Text
                        color={wordmarkColor}
                        fontFamily="'Plus Jakarta Sans', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
                        fontSize={showDescriptor ? '1.65rem' : { base: 'lg', md: 'xl' }}
                        fontWeight='800'
                        letterSpacing='-0.04em'
                        lineHeight='1'
                        whiteSpace='nowrap'
                    >
                        Peregin
                    </Text>
                    {showDescriptor && (
                        <Text mt='1' color='fg.muted' fontSize='xs' lineHeight='1.25' whiteSpace='nowrap'>
                            {t('brand.descriptor')}
                        </Text>
                    )}
                </Stack>
            )}
        </HStack>
    );
};

export default PereginBrand;
